import React from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { TextInputField } from "../bootstrap/TextInputField";
import { PromoterFormDetails } from "../general/PromoterFormDetails";

export function PromoterIdentification({
  step,
  numberOfSteps,
  formikValues,
  handleGoBack,
  handleNextStep,
  printing,
}) {
  const intl = useIntl();

  return (
    <div>
      <h4 className="text-primary mb-0">
        <FormattedMessage id="eaevaluationform.promotersidentification" />
      </h4>
      <small className="text-secondary text-uppercase">
        {intl.formatMessage(
          { id: "all.step" },
          { step: step, numberOfSteps: numberOfSteps }
        )}
      </small>
      <PromoterFormDetails
        promotersMetaDataList={formikValues.promotersMetaData}
      />

      {!printing && (
        <div className="form-actions mt-5">
          <button
            className="btn btn-link"
            type="button"
            onClick={() => handleGoBack()}
          >
            <FormattedMessage id="all.back" />
          </button>

          <button
            className="btn btn-primary"
            type="button"
            onClick={() => handleNextStep()}
          >
            <FormattedMessage id="all.nextStep" />
          </button>
        </div>
      )}
    </div>
  );
}
